import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  okStringResponseSchema,
  orgIdResponseSchema,
} from './common-responses';

export const onboardingOrgSetupBodyV20260601Schema = z.object({
  orgName: z.string().optional(),
});

export type OnboardingOrgSetupBody = z.infer<
  typeof onboardingOrgSetupBodyV20260601Schema
>;

export const onboardingReferralBodyV20260601Schema = z.object({
  referralCode: z.string(),
});

export type OnboardingReferralBody = z.infer<
  typeof onboardingReferralBodyV20260601Schema
>;

export class OnboardingOrgSetupV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'onboarding-org-setup-2026-06-01' as const;

  readonly name = OnboardingOrgSetupV20260601Schema.version;
  readonly schema = onboardingOrgSetupBodyV20260601Schema;
  readonly response = orgIdResponseSchema;
}

export class OnboardingReferralV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'onboarding-referral-2026-06-01' as const;

  readonly name = OnboardingReferralV20260601Schema.version;
  readonly schema = onboardingReferralBodyV20260601Schema;
  readonly response = okStringResponseSchema;
}

export const ONBOARDING_API_SCHEMAS = [
  OnboardingOrgSetupV20260601Schema,
  OnboardingReferralV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
